import type { IconType } from 'react-icons';
import {
  FiBookOpen,
  FiThermometer,
  FiRepeat,
  FiSettings,
  FiBarChart2,
  FiMapPin,
  FiCamera,
  FiMail,
} from 'react-icons/fi';

export type WhatsNewFeature = {
  icon: IconType;
  title: string;
  description: string;
};

export type WhatsNewEntry = {
  version: string;
  title: string;
  features: WhatsNewFeature[];
};

export const WHATS_NEW: WhatsNewEntry[] = [
  {
    version: '1.27.0',
    title: "What's new on the web",
    features: [
      {
        icon: FiBookOpen,
        title: 'Journal',
        description:
          'A private timeline for notes and phone calls—only you can see it. Open Journal from the sidebar or bottom nav.',
      },
      {
        icon: FiBarChart2,
        title: 'Exchange logging & history',
        description:
          'Log pickups and drop-offs from the calendar, then review stats and a full timeline under Exchange history.',
      },
      {
        icon: FiMapPin,
        title: 'GPS check-ins',
        description:
          'Record your location at exchanges using your browser’s location permission. List and manage check-ins anytime.',
      },
      {
        icon: FiCamera,
        title: 'Receipt scanner',
        description:
          'When you attach a receipt photo to a new expense, we read amount, merchant, category, and date to pre-fill the form.',
      },
      {
        icon: FiMail,
        title: 'Richer email exports',
        description:
          'In Settings → Export, choose date range plus journal, check-ins, and exchange compliance—alongside messages, accounting, and calendar.',
      },
    ],
  },
  {
    version: '1.22.0',
    title: "What's New in Harbor",
    features: [
      {
        icon: FiThermometer,
        title: 'Temp Check',
        description:
          'Messages are analyzed in real time as you type, helping you keep conversations calm and constructive.',
      },
      {
        icon: FiRepeat,
        title: 'Suggested Rewrites',
        description:
          'When a message sounds heated, Temp Check offers a calmer alternative you can use with one tap.',
      },
      {
        icon: FiSettings,
        title: "You're in Control",
        description: 'Turn Temp Check on or off anytime from Settings.',
      },
    ],
  },
];
